import redAlertSvg from './redAlert.svg';
import styles from './SecurityChecksPrompt.module.css';
import { useGetSecurityCheckRequirements } from '../../SLSecurityCheckBanner/SLSecurityCheckBanner';

export const SecurityChecksPrompt = () => {
    const { isAnyRequirementVisible, loadingFundingRequirement } =
        useGetSecurityCheckRequirements();

    if (loadingFundingRequirement) return null;
    if (!isAnyRequirementVisible) return null;

    return (
        <div className={styles.wrap}>
            <div className={styles.iconContainer}>
                <img src={redAlertSvg} alt="Alert" />
            </div>
            <div className={styles.textContainer}>
                <div className={styles.heading}>
                    You still need to finish your security checks before you can
                    use your spending limit
                </div>
                <div className={styles.bodyText}>
                    Once they’re done you’ll be able to use your spending limit
                    to finish your purchase.
                </div>
            </div>
        </div>
    );
};
